<script setup>
import { ref } from 'vue';
import Button from 'dashboard/components-next/button/Button.vue';
import CardLayout from 'dashboard/components-next/CardLayout.vue';
import SuggestedRules from './SuggestedRules.vue';
import RuleInput from './RuleInput.vue';

defineProps({
  items: { type: Array, default: () => [] },
  examples: { type: Array, default: () => [] },
  suggestedTitle: { type: String, required: true },
  addAllLabel: { type: String, required: true },
  addThisLabel: { type: String, required: true },
  addButtonLabel: { type: String, required: true },
  emptyMessage: { type: String, required: true },
  inputPlaceholder: { type: String, required: true },
  saveLabel: { type: String, required: true },
});

const emit = defineEmits(['add', 'addAll', 'remove']);
const draft = ref('');
const showExamples = ref(true);
</script>

<template>
  <div class="flex flex-col gap-4">
    <SuggestedRules
      v-if="showExamples"
      :title="suggestedTitle"
      :items="examples"
      :add-all-label="addAllLabel"
      :add-this-label="addThisLabel"
      @add="emit('add', $event)"
      @add-all="emit('addAll')"
      @close="showExamples = false"
    />
    <div>
      <Button
        :label="addButtonLabel"
        variant="faded"
        color="slate"
        size="sm"
        @click="showExamples = true"
      />
    </div>
    <p v-if="!items.length" class="mb-0 text-sm text-n-slate-11">
      {{ emptyMessage }}
    </p>
    <CardLayout v-for="(item, index) in items" :key="`${item}-${index}`">
      <div class="flex items-center justify-between w-full gap-3">
        <span class="text-sm text-n-slate-12">{{ item }}</span>
        <Button
          icon="i-lucide-trash"
          variant="ghost"
          color="slate"
          size="xs"
          @click="emit('remove', index)"
        />
      </div>
    </CardLayout>
    <RuleInput
      v-model="draft"
      :placeholder="inputPlaceholder"
      :label="saveLabel"
      @add="emit('add', $event)"
    />
  </div>
</template>
